import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const resetHomeSetupApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        serviceCall({
            url: apiConstants.HOME_MAINTENANCE.RESET_HOME_SETUP,
            method: 'delete',
            data: data,
        })
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}

export default resetHomeSetupApi
